import { publishMQTTMessage, AnalyticsEvent } from './sendToRabbitMQ';
import {
  getSessionId,
  getUserIdentifiers,
  getNetworkInfo,
  getDeviceInfo,
  getSessionInfo,
  getPageInfo,
  getEnvironment,
  buildIdentifiers,
} from './analyticsEvents'; 
import { CHANNEL, DATA_LAYER_EVENTS, DEFAULT_LANGUAGE, DESCRIPTION_TEMPLATES, EVENT_ACTIONS, EVENT_CATEGORIES, EVENT_TYPE, STORAGE_KEYS, USER_TYPES } from './constant';

export async function sendFormSubmitEvent(
  formName: string,
  m_canvas?: {
    source: string;
    type: "Page" | "Component";
    id: string;
    component?: string;
    name: string;
    action: string;
    label: string;
    position?: string;
  },
): Promise<void> {
  const { sessionId, isNewUser } = getSessionId();
  const { userId, deviceId } = getUserIdentifiers();
  const device = await getDeviceInfo();
  const network = getNetworkInfo();
  const session = getSessionInfo(isNewUser);
  const { pageTitle, pageReferrer, currentUrl } = getPageInfo();

  const event: AnalyticsEvent = {
    date: new Date().toISOString().split('T')[0],
    event_type: EVENT_TYPE,
    event_category: EVENT_CATEGORIES.FORM_INTERACTION,
    event_action: EVENT_ACTIONS.FORM_SUBMIT,
    event_label: formName,
    timestamp: {
      event_logtime: Date.now(),
      event_logtimestamp: new Date().toISOString(),
      cdl_time: '',
      cdl_timestamp: '',
      de_ingestion_id: '',
    },
    identifiers: buildIdentifiers({
      deviceId,
      resolvedSessionId: sessionId,
      userId,
      environment: getEnvironment(),
      appLanguage: navigator.language || document.documentElement.lang || DEFAULT_LANGUAGE,
      userType: localStorage.getItem(STORAGE_KEYS.USER_TYPE) || USER_TYPES.GUEST,
    }),
      device,
      network,
      session,
      page: {
        page_name: pageTitle,
        previous_page_name: pageReferrer,
        url: currentUrl,
      },
      attribute: {
        description: DESCRIPTION_TEMPLATES.formSubmitted(formName),
        channel: CHANNEL.WEB,
        pagename: pageTitle,
      },
      m_canvas: m_canvas,
    };

  // Non-blocking publish to MQTT
  // Topic is determined automatically based on instance (dtdl.website or payzy.website)
  publishMQTTMessage(event);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: DATA_LAYER_EVENTS.FORM_SUBMIT, ...event } as unknown as FormSubmitEventData);
}